module.exports = __webpack_public_path__ + "img/7.223de363.jpg";